export default __webpack_public_path__ + "static/media/search icon.a99de9bc.svg";